import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import estilos from "./CuadroInspectorComponent.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InspectoresFormComponent from "./InspectoresFormComponent";
import { useSelector, useDispatch } from "react-redux";
import { getInspectores, updateInspector } from "../../../redux/DucksUnidadInspeccion/InspectoresDuck";
import PromoverInspectorComponent from "./PromoverInspectorComponent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
library.add(faPlus);
import { DataGrid, GridToolbarQuickFilter, } from "@mui/x-data-grid";
import ConfiguracionFirmaComponent from "../Configuracion/FirmaInspector/ConfiguracionFirmaComponent";
import CredencialComponent from "./CredencialComponent";
import moment from "moment";
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        textAlign: "right",
      }}
    >
      {/*<GridToolbarFilterButton Title='Filtro'/>*/}
      <GridToolbarQuickFilter />
    </Box>
  );
}
function PanelInspectores(props) {
  const dispatch = useDispatch();

  const [isVisible, setIsVisible] = React.useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    overflow: "scroll",
    height: "85%",
  };
  const styleBoxFirma = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const styleBox = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const [inspectores, setInspectores] = React.useState([]);
  React.useEffect(() => {
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
  }, []);

  const [open, setOpen] = React.useState(false);
  const [inspectorModify, setInspectorModify] = React.useState(null);

  const handleOpen = () => setOpen(true);

  const [openPromover, setOpenPromover] = React.useState(false);
  const [inspectorPromover, setInspectorPromover] = React.useState(null);
  const handleOpenPromover = () => setOpenPromover(true);

  const [openEliminarInspector, setOpenEliminarInspector] = React.useState(false);
  const [eliminarDataInspector, setEliminarDataInspector] = React.useState();

  const manejarOpen = () => {
    isVisible === false ? setIsVisible(true) : setIsVisible(false);
  };
  const handleClose = () => {
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
    setInspectorModify(null);
    setOpen(false);
  };

  const handleModify = (inspector) => {
    handleOpen();
    setInspectorModify(inspector);
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
  };

  const handlePromover = (inspector) => {
    handleOpenPromover();
    setInspectorPromover(inspector);
  };
  const handleClosePromover = () => {
    setInspectorPromover(null);
    setOpenPromover(false);
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
  };

  const actualizarInspectores = () => {
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
  };

  const modalFormInspectores = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <InspectoresFormComponent
              inspectorModify={inspectorModify}
              onClose={handleClose}
              actualizarInspectores={actualizarInspectores}
            ></InspectoresFormComponent>
          </Box>
        </Fade>
      </Modal>
    );
  };
  const modalPromoverInspector = () => {
    return (
      <Modal
        open={openPromover}
        onClose={handleClosePromover}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {
            <PromoverInspectorComponent
              inspectorPromover={inspectorPromover}
              onClose={handleClosePromover}
            ></PromoverInspectorComponent>
          }
        </Box>
      </Modal>
    );
  };




  React.useEffect(() => {
    dispatch(getInspectores()).then((res) => {
      setInspectores(res.payload.data.data);
    });
  }, [inspectorModify, open,openEliminarInspector]);

  let columns = [
    {
      field: "nombre", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
      headerName: "Nombre Completo", flex: 1, resizable: true,
    },
    {
      field: "correo", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
      headerName: "Correo Electronico", flex: 1, resizable: true,
    },
    {
      field: "puesto", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
      headerName: "Puesto", flex: 1, resizable: true,
    },
    {
      field: "estatus", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
      headerName: "Estatus", flex: 1, resizable: true,
    },
    {
      field: "accion", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
      headerName: "Acciones", flex: 1, resizable: true,
      renderCell: (params) => {
        const inspector = params.row; // los datos de la fila
        return (
          <>
            <Tooltip title="Modificar">
              <IconButton onClick={() => handleModify(params.row?.inspector)} size="small" color="warning" >
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">
              <IconButton onClick={() => handleOpenEliminarInspector(params.row?.inspector)} size="small" color="error" >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            {/*<Tooltip title="Firma">
              <IconButton onClick={() => handleOpenFirma()} size="small" color="primary" >
                <DrawIcon />
              </IconButton>
            </Tooltip>
            {params.row?.estatus == "En capacitación" && (
              <Tooltip title="Promover">
                <IconButton onClick={() => handlePromover(inspector.inspector)} size="small" color="success" >
                  <PublishIcon />
                </IconButton>
              </Tooltip>
            )}*/}
          </>
        );
      },
    },
  ];
  const rows = [];
  inspectores?.map((anexo, index) => {
    let estatus = "";
    if (anexo?.isactivo) estatus = "Activo";
    if (
      anexo?.isactivo == false ||
      anexo.isactivo == undefined ||
      anexo.isactivo == null
    )
      estatus = "Inactivo";
    if (anexo?.iscapacitacion == 1 && anexo?.isactivo)
      estatus = "En capacitación";
    if (
      anexo.iscapacitacion == 0 &&
      anexo.acreditacion != null &&
      anexo.acreditacion != undefined &&
      anexo?.isactivo
    )
      estatus = "Acreditado";

    rows.push({
      id: index,
      idinspector: anexo?.idinspector,
      nombre: anexo?.nombre + ' ' + anexo?.apellidos,
      correo: anexo?.login?.usuario,
      puesto: anexo?.catalogopuestos?.nombre,
      estatus: estatus, inspector: anexo
    });
  });

  const [openFirma, setOpenFirma] = React.useState(false);
  const handleOpenFirma = () => setOpenFirma(true);
  const handleCloseFirma = () => setOpenFirma(false);

  const modalSubirFirma = (inspector) => {
    return (
      <Modal
        open={openFirma}
        onClose={handleCloseFirma}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleBoxFirma}>
          <div className='row text-center' style={{ backgroundColor: 'white' }}>
            <ConfiguracionFirmaComponent idinspector={props?.inspector?.idinspector} cerrar={handleCloseFirma}></ConfiguracionFirmaComponent>
          </div>
        </Box>
      </Modal>
    )
  }
  
  const handleOpenEliminarInspector = (data) => {
    setOpenEliminarInspector(true);
    setEliminarDataInspector(data)
  }
  const handleCloseEliminarInspector = () => setOpenEliminarInspector(false);

  const modalEliminarInspector = () => {
    return (
      <Modal
        open={openEliminarInspector}
        onClose={handleCloseEliminarInspector}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleBox}>
          <div className='text-center'>
            ¿Desea realmente dar de Baja a este Inspector?<br /><br />
            <strong>{eliminarDataInspector?.nombre} {eliminarDataInspector?.apellidos} </strong> <br /><br />
            <button className='btn btn-danger' onClick={() => handleRemoveInspector(eliminarDataInspector?.idinspector)}> Dar de Baja</button>
            <button className='btn btn-secondary ms-3' onClick={() => setOpenEliminarInspector(false)}> Canelar</button>
          </div>
        </Box>
      </Modal>
    )
  }
  const handleRemoveInspector = async () => {
    const fechaHoy = moment().format('YYYY-MM-DD')
    let dataEliminar = {
      idinspector: eliminarDataInspector?.idinspector,
      estatus: 'Inactivo', fechabaja: new Date(fechaHoy).toISOString(),
      isactivo: false
    }
    await dispatch(updateInspector({ data: dataEliminar }))
    setOpenEliminarInspector(false)
  }
  return (
    <Fragment>
      <h3 style={{ textAlign: "center", fontWeight: "bold" }}>INSPECTORES</h3>
      <div className="col-12 text-end">
        <button
          style={{ margin: "1%" }}
          className={`btn btn-success ${estilos.zoom}`}
          onClick={handleOpen} >
          <FontAwesomeIcon icon={faPlus} /> Agregar Inspector
        </button>
      </div>

      <div className="col-12 mt-1 ms-3 text-center">
        <div style={{ height: 650, width: "100%", color: "black" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            components={{
              Toolbar: QuickSearchToolbar,
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: "idinspector", sort: "ASC" }],
              },
            }}
            sx={{
              boxShadow: 0,
              color: "black",
              border: 0,
              "& .MuiDataGrid-cell": {
                display: "block",
                position: "relative",
                textAlign: "center",
              },
            }}
          />
        </div>
      </div>

      <br />
      {modalPromoverInspector()}
      {modalFormInspectores()}
      {modalSubirFirma()}
      {modalEliminarInspector()}
    </Fragment>
  );
}

export default withRouter(PanelInspectores);
